export class CustomError extends Error {
  code: string;

  // Optional field to pass additional error details; allows flexibility in error handling by accepting any data type.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(message: string, code: string, data?: any) {
    super(message);
    this.code = code;
    this.data = data;
  }
}
